import * as Sentry from '@sentry/react';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import type { ButtonSize, ButtonStyles } from 'src/app/components/Elements/Button';
import Button from 'src/app/components/Elements/Button';
import type { Facility, ScrolledToSegmentPayload } from 'src/app/types';

interface ShareButtonProps {
  facility: Facility;
  segmentTrack: (event: UnifiedEvent, payload: { [key: string]: ScrolledToSegmentPayload }) => void;
  pagepath: ScrolledToSegmentPayload;
  style?: ButtonStyles;
  size?: ButtonSize;
}

export const ShareButton = ({
  facility,
  segmentTrack,
  pagepath,
  style = 'secondary',
  size = 'large',
}: ShareButtonProps) => {
  if (!facility?.address) return null;
  const { address, phone, fax } = facility;
  const { name, city, state, zipCode } = address;

  const isShareSheetAvailable = Boolean(navigator?.share);
  const handleClick = () => {
    if (isShareSheetAvailable) {
      navigator
        .share({
          title: `Share Capsule with your Doctor`,
          text: `ADDRESS\n${name}\n${address?.address}\n${city}, ${state} ${zipCode}\n\nPHONE\n${phone}\n\nFAX\n${fax}`,
        })
        .catch(error => Sentry.captureException(error));
      segmentTrack(UNIFIED.shareCapsuleWithDoctor, { pagepath });
    }
  };
  return (
    <>
      {(isShareSheetAvailable && (
        <Button style={style} size={size} onClick={handleClick}>
          Share
        </Button>
      )) ??
        null}
    </>
  );
};
